import { showOnlyMandatoryClicked } from "../../actions/filters";

import { connect } from "react-redux";

import CheckBox from "../../../../shared_components/check_box";

const mapStateToProps = (state) => {
  const value = "ignore";
  const checked = state.filters.showOnlyMandatory == "checked";
  const title = "Show only mandatory standards";
  const extraHtmlClasses = { "col-md-3": true };

  return { value, checked, title, extraHtmlClasses };
};

const mapDispatchToProps = dispatch => ({
  onClick: () => { dispatch(showOnlyMandatoryClicked()); }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckBox);
